import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';


@Injectable()
export class AuthBasicGuard  {


	constructor(
		private router: Router,
		private authService: AuthenticationService
	) {}


	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	) {

		if( !this.authService.isConnected() ) {

			window.localStorage.setItem( "redirectAfterLogin", state.url );
			this.router.navigate( ['auth/login'] );
			return false;

		}

		return true;
	}

}
